export default __webpack_public_path__ + "static/media/stress.ad4f911c.jpg";